import { cva } from '@/styled-system/css';

export const upsellBannerHeaderRecipe = cva({
  base: {
    'display': {
      lg: 'inline',
    },

    'paddingInlineEnd': {
      lgDown: 'Upsell.Header.gap.content-toClose',
    },

    '& > [data-c11n-component="Heading"]': {
      color: 'inherit',
      textStyle: 'body-bold',
      display: {
        lg: 'inline',
      },
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'UpsellBanner.Header.neutral.text',
      },
      soft: {
        color: 'UpsellBanner.Header.soft.text',
      },
      hero: {
        color: 'UpsellBanner.Header.hero.text',
      },
      impact: {
        color: 'UpsellBanner.Header.impact.text',
      },
    },
  },
});
